<template>
  <button :class="classes" class="c-header-toggler header-toggler">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="icon icon-lg"
      viewBox="0 0 512 512"
      role="img"
    >
      <rect
        width="352"
        height="32"
        x="80"
        y="96"
        fill="var(--ci-primary-color, #3042aa)"
        class="ci-primary"
      ></rect>
      <rect
        width="352"
        height="32"
        x="80"
        y="240"
        fill="var(--ci-primary-color, #3042aa)"
        class="ci-primary"
      ></rect>
      <rect
        width="352"
        height="32"
        x="80"
        y="384"
        fill="var(--ci-primary-color, #3042aa)"
        class="ci-primary"
      ></rect>
    </svg>
  </button>
</template>

<script>
export default {
  props: { classes: [Array, String] }
}
</script>

<style></style>
